<template>
  <div class="introduce">
    <div class="image">
      <img :src="spotlist.cover" alt="" width="100%" />
    </div>
    <div class="content">
      <div class="bigtitle">{{ spotlist.name }}</div>
      <div class="txet" v-html="spotlist.text"></div>
    </div>
    <div class="appointment-bottom">
      <div class="sumbit" @click="sumbit">立即报名</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      id: "",
      spotlist: "",
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.$axios.get(`/book/activInfo/${this.id}`).then((res) => {
      this.spotlist = res.data.bookActiv;
    });
  },
  methods: {
    sumbit() {
      this.$router.push("/activity/" + this.id);
    },
  },
};
</script>
<style scoped lang="less">
.introduce {
  width: 100%;
  min-height: 100%;
  position: relative;
  .image {
    width: 100%;
  }
  .content {
    position: relative;
    top: -0.2rem;
    background-color: #fff;
    border-top-left-radius: 0.15rem;
    border-top-right-radius: 0.15rem;
    padding: 0.2rem;
    box-sizing: border-box;
    .bigtitle {
      font-size: 0.24rem;
      font-weight: 700;
      margin-bottom:0.3rem;
    }
  }
  .appointment-bottom {
    width: 100%;
    padding: 0 0.2rem;
    box-sizing: border-box;
    position: absolute;
    bottom: 0.2rem;
    .sumbit {
      background-color: #a78d60;
      line-height: 0.4rem;
      color: #fff;
      width: 100%;
      text-align: center;
      border-radius: 0.07rem;
    }
  }
}
</style>